<template>
    <div class="card mb-3">
        <div class="card-body">
            <router-link v-if="($store.state.role == 'branches' || $store.state.role == 'izbank-admin')" :to="{name: 'bankBranches.cardBody.branch'}" class="btn btn-success">ثبت سفارش جسم کارت</router-link>
            <hr v-if="($store.state.role == 'branches' || $store.state.role == 'izbank-admin')">
            <Loading v-if="showLoading" />
            <div class="table-responsive" v-if="rows.length">
                <table class="table table-hover table-bordered">
                    <thead>
                        <tr>
                            <th>شناسه سفارش</th>
                            <th>نام شعبه</th>
                            <th>وضعیت سفارش</th>
                            <th>تاریخ</th>
                            <th>ساعت</th>
                            <th>عملیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row,index) in rows" @click="openOrder(row.order_id,row.order_type_id)" :key="index">
                            <td>{{ row.themeOrderId }}</td>
                            <td>{{ row.domainData.fullName }}</td>
                            <td>{{ row.orderStatus.title }}</td>
                            <td>{{ new Date(row.datetime).toLocaleDateString('fa-IR') }}</td>
                            <td>{{ new Date(row.datetime).toLocaleTimeString('fa-IR') }}</td>
                            <td>
                                <router-link :to="{name: 'bankBranches.cardBody.branch.single',params: {id: row.themeOrderId}}" class="d-inline-block ml-2"><i class="ti-eye"></i></router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <Pagination v-if="count > 10" :pages="pages" :currentPage="currentPage" :prevPageMethod="prevPage" :nextPageMethod="nextPage" :changePageMethod="changePage" />
                <span>تعداد کل ردیف ها : {{ count }} ردیف</span>
            </div>
            <div class="alert alert-info mb-0" v-else>
                <p class="mb-0">داده ای یافت نشد</p>
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from '../../Partials/Pagination';
export default {
    name: 'Index',
    components: {Pagination},
    data(){
        return {
            rows: [],
            showLoading: true,
            count: 0,
            currentPage: 1,
            limit: 10,
            pages: []
        }
    },
    methods: {
        getData(){
            const postedData = {
                herSelfOrder: this.$store.state.role == 'warehouse' ? false : true,
                take: this.limit,
                page: this.currentPage
            };
            this.$api.post('Themes/GetThemeOrder',postedData).then(({data}) => {
                if(data.status){
                    this.rows = data.result.data;
                    this.count = data.result.total;
                    let calcPages = Math.ceil((this.count ? this.count : this.limit) / this.limit);
                    calcPages = calcPages > 1 ? calcPages : 1
                    let pagesArray = [];
                    for(let i = 1;i <= calcPages;i++)
                        pagesArray.push(i);
                    this.pages = pagesArray;
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        changePage(e,page = null){
            e.preventDefault();
            if(page)
                this.currentPage = page;
            this.getData();
        },
        nextPage(e){
            e.preventDefault();
            this.currentPage = this.currentPage + 1;
            this.changePage();
        },
        prevPage(e){
            e.preventDefault();
            this.currentPage = this.currentPage - 1;
            this.changePage();
        },
    },
    created(){
        this.getData();
    }
}
</script>